import React from "react";
import styled from "styled-components";
import {
  FaAddressBook,
  FaHome,
  FaCalendar,
  FaDatabase,
  FaMap,
  FaFlag,
  FaPlus,
  FaSignOutAlt,
} from "react-icons/fa";

import useAuth from "hooks/useAuth";

export const menuItems = [
  { href: "/", name: "Home", icon: <FaHome /> },
  { href: "/contact", name: "Contact", icon: <FaAddressBook /> },
  { href: "/source", name: "Source", icon: <FaDatabase /> },
  { href: "/year", name: "Year", icon: <FaCalendar /> },
  { href: "/country", name: "Country", icon: <FaMap /> },
  { href: "/ethnicity", name: "Ethnicity", icon: <FaFlag /> },
  { href: "/age", name: "Age", icon: <FaPlus /> },
];

function Menu() {
  const { requestLogout } = useAuth();

  return (
    <Container>
      <UL>
        {menuItems.map(({ name, href, icon }) => (
          <LI key={name}>
            <Link href={href}>
              <Icon>{icon}</Icon>
              <Name>{name}</Name>
            </Link>
          </LI>
        ))}
        <LI>
          <Button onClick={requestLogout}>
            <Icon>
              <FaSignOutAlt />
            </Icon>
            <Name>Logout</Name>
          </Button>
        </LI>
      </UL>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: stretch;
  position: fixed;
  width: 100%;
  background: #000000;
  z-index: 1;
`;

const UL = styled.ul`
  list-style-type: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
`;

const LI = styled.li`
  float: left;
  position: static;
  padding: 0;
`;

const Link = styled.a`
  color: #fff;
  font-weight: bold;
  text-align: center;
  padding: 0.8rem 1rem 0.4rem 1rem;
  text-decoration: none;
  letter-spacing: 2px;
  border-bottom: 0.4rem solid #000;
  display: flex;
  flex-direction: column;

  &:hover {
    border-bottom: 0.4rem solid #fff;
  }
`;

const Button = styled.button`
  color: #fff;
  font-weight: bold;
  text-align: center;
  padding: 0.8rem 1rem 0.4rem 1rem;
  letter-spacing: 2px;
  display: flex;
  flex-direction: column;
  background: transparent;
  border: 0;
  align-items: center;

  &:hover {
    border-bottom: 0.4rem solid #fff;
  }
`;

const Icon = styled.span`
  font-size: 1.5rem;
`;

const Name = styled.span`
  margin-top: 0.2rem;
  font-size: 0.75rem;
`;

export default Menu;
